<div class="admin-layout">
  <!-- Sidebar -->
  <aside class="sidebar" [class.collapsed]="isCollapsedView" [class.mobile-open]="isMobileMenuOpen"
         (mouseenter)="onSidebarMouseEnter()"
         (mouseleave)="onSidebarMouseLeave()">
    <!-- Logo Section -->
    <div class="sidebar-header">
      <!--      <div class="logo-container">-->
      <!--        <div class="logo-icon">-->
      <!--          <img src="images/nacc-logo.png" alt="โลโก้สำนักงานมาตรฐานสินค้าเกษตรและอาหารแห่งชาติ" class="logo-image">-->
      <!--        </div>-->
      <!--        @if (!isCollapsedView) {-->
      <!--          <div class="logo-text">-->
      <!--            <span class="logo-name">สำนักงานมาตรฐานสินค้าเกษตรและอาหารแห่งชาติ</span>-->
      <!--            <span class="logo-version">มกอช.</span>-->
      <!--          </div>-->
      <!--        }-->
      <!--      </div>-->
      <a routerLink="/secure/admin" class="logo-link" [class.gap-0]="isCollapsedView">
        <img src="images/logo2.png" alt="Logo" class="logo-img"/>
        <div class="logo-text">
          <span class="logo-title">
            ACFS e-Coding
          </span>
          <span class="logo-build-version">
            เวอร์ชัน {{ appVersion() || '-' }}
          </span>
        </div>
      </a>
    </div>

    <!-- Navigation -->
    <nav class="sidebar-nav">
      <ul class="nav-list" [hidden]="!isStaff()">
        <li class="nav-item">
          <a (click)="goToPortalSystem()" class="nav-link">
            <span class="nav-icon">
               <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-square-arrow-out-up-left-icon lucide-square-arrow-out-up-left">
              <path d="M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6"/>
              <path d="m3 3 9 9"/>
              <path d="M3 9V3h6"/>
            </svg>
              <!--                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"-->
              <!--                               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"-->
              <!--                               class="lucide lucide-undo2-icon lucide-undo-2"><path d="M9 14 4 9l5-5"/><path-->
              <!--                            d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11"/></svg>-->
                        </span>
            <span class="nav-text">ไปที่ e-Portal</span>
          </a>
        </li>
      </ul>
      <!--      @if (!isCollapsedView) {-->
      <!--        <div class="nav-section">-->
      <!--          <span class="nav-section-title">Main Menu</span>-->
      <!--        </div>-->
      <!--      }-->
      <!--      <ul class="nav-list">-->
      <!--        <li class="nav-item">-->
      <!--          <a routerLink="/dashboard" routerLinkActive="active" class="nav-link"-->
      <!--             [attr.title]="isCollapsedView ? 'Dashboard' : null">-->
      <!--            <span class="nav-icon">-->
      <!--              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"-->
      <!--                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">-->
      <!--                <path-->
      <!--                  d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">-->
      <!--                </path>-->
      <!--                <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>-->
      <!--                <line x1="12" y1="22.08" x2="12" y2="12"></line>-->
      <!--              </svg>-->
      <!--            </span>-->
      <!--            <span class="nav-text">Dashboard</span>-->
      <!--          </a>-->
      <!--        </li>-->
      <!--      </ul>-->

      <ul class="nav-list" [hidden]="!isStaff()">
        <li class="nav-item nav-item-has-popup" (mouseenter)="showPopup('certificateRequest')"
            (mouseleave)="hidePopup()">
          <a class="nav-link nav-link-toggle" (click)="toggleSubMenu('certificateRequest')"
             [attr.title]="isCollapsedView ? null : null"
             [attr.aria-expanded]="subMenuStates['certificateRequest']"
             [class.expanded]="subMenuStates['certificateRequest']">
          <span class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </span>
            <span class="nav-text">การขอรหัสการรับรองฯ</span>
            @if (!isCollapsedView) {
              @if (subMenuStates['certificateRequest']) {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              }
            }
          </a>

          @if (isCollapsedView) {
            <div class="nav-popup">
              <div class="nav-popup-header">
                <span class="nav-popup-title">การขอรหัสการรับรองฯ</span>
              </div>
              <ul class="nav-popup-list">
                <li class="nav-popup-item">
                  <a routerLink="/certificate-request/request-wait-check" routerLinkActive="active"
                     class="nav-popup-link">
                    <span class="nav-popup-text">คำขอรอตรวจสอบ</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/certificate-request/thaitraces" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">รายการคำขอทั้งหมด</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/certificate-request/cert-code-search" routerLinkActive="active"
                     class="nav-popup-link">
                    <span class="nav-popup-text">ค้นหารหัสรับรองมาตรฐานสินค้าเกษตร</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/certificate-request/thaitraces-search" routerLinkActive="active"
                     class="nav-popup-link">
                    <span class="nav-popup-text">ค้นหาคำขอ ThaiTraces</span>
                  </a>
                </li>
              </ul>
            </div>
          }
        </li>
      </ul>

      <ul class="nav-list nav-submenu" [hidden]="!isStaff()"
          [class.collapsed]="isCollapsedView || !subMenuStates['certificateRequest']">
        <li class="nav-item">
          <a routerLink="/certificate-request/request-wait-check" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'คำขอรอตรวจสอบ' : null">
            <span class="nav-text">คำขอรอตรวจสอบ</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/certificate-request/thaitraces" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'รายการคำขอทั้งหมด' : null">
            <span class="nav-text">รายการคำขอทั้งหมด</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/certificate-request/cert-code-search" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ค้นหารหัสรับรองมาตรฐานสินค้าเกษตร' : null">
            <span class="nav-text">ค้นหารหัสรับรองมาตรฐานสินค้าเกษตร</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/certificate-request/thaitraces-search" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ค้นหาคำขอ ThaiTraces' : null">
            <span class="nav-text">ค้นหาคำขอ ThaiTraces</span>
          </a>
        </li>
      </ul>

      <ul class="nav-list" [hidden]="!isStaff()">
        <li class="nav-item nav-item-has-popup" (mouseenter)="showPopup('importerCode')" (mouseleave)="hidePopup()">
          <a class="nav-link nav-link-toggle" (click)="toggleSubMenu('importerCode')"
             [attr.title]="isCollapsedView ? null : null"
             [attr.aria-expanded]="subMenuStates['importerCode']"
             [class.expanded]="subMenuStates['importerCode']">
          <span class="nav-icon">
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-ship-icon lucide-ship">
                  <path d="M12 10.189V14"/>
                  <path d="M12 2v3"/>
                  <path d="M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"/>
                  <path
                    d="M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"/>
                  <path
                    d="M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>
                </svg>
          </span>
            <span class="nav-text">กำหนดรหัสสำหรับผู้นำเข้าฯ</span>
            @if (!isCollapsedView) {
              @if (subMenuStates['importerCode']) {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              }
            }
          </a>

          @if (isCollapsedView) {
            <div class="nav-popup">
              <div class="nav-popup-header">
                <span class="nav-popup-title">การกำหนดรหัสสำหรับผู้นำเข้าฯ</span>
              </div>
              <ul class="nav-popup-list">
                <li class="nav-popup-item">
                  <a routerLink="/import-request/declarations" routerLinkActive="active"
                     class="nav-popup-link">
                    <span class="nav-popup-text">คำขอนำเข้ารอตรวจสอบ</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/import-request/importer-code" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">การกำหนดรหัสเครื่องหมายเลขรับรองมาตรฐานสำหรับผู้นำเข้า</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/import-request/importer-search" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">สืบค้นข้อมูลใบรับรองมาตรฐาน สำหรับผู้นำเข้า</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/import-request/tas-license-fetch" routerLinkActive="active"
                     class="nav-popup-link">
                    <span class="nav-popup-text">ดึงข้อมูลจาก Tas-License</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/import-request/tas-license-search" routerLinkActive="active"
                     class="nav-popup-link">
                    <span class="nav-popup-text">สืบค้นข้อมูลสำหรับ Tas-License</span>
                  </a>
                </li>
              </ul>
            </div>
          }
        </li>
      </ul>

      <ul class="nav-list nav-submenu" [hidden]="!isStaff()"
          [class.collapsed]="isCollapsedView || !subMenuStates['importerCode']">
        <li class="nav-item">
          <a routerLink="/import-request/declarations" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'คำขอนำเข้ารอตรวจสอบ' : null">
            <span class="nav-text">คำขอนำเข้ารอตรวจสอบ</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/import-request/importer-code" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'การกำหนดรหัสเครื่องหมายเลขรับรองมาตรฐานสำหรับผู้นำเข้า' : null">
            <span class="nav-text">การกำหนดรหัสเครื่องหมายเลขรับรองมาตรฐานสำหรับผู้นำเข้า</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/import-request/importer-search" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'สืบค้นข้อมูลใบรับรองมาตรฐาน สำหรับผู้นำเข้า' : null">
            <span class="nav-text">สืบค้นข้อมูลใบรับรองมาตรฐาน สำหรับผู้นำเข้า</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/import-request/tas-license-fetch" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ดึงข้อมูลจาก Tas-License' : null">
            <span class="nav-text">ดึงข้อมูลจาก Tas-License</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/import-request/tas-license-search" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'สืบค้นข้อมูลสำหรับ Tas-License' : null">
            <span class="nav-text">สืบค้นข้อมูลสำหรับ Tas-License</span>
          </a>
        </li>
      </ul>

      <ul class="nav-list" [hidden]="!isAdmin()">
        <li class="nav-item nav-item-has-popup" (mouseenter)="showPopup('masterData')" (mouseleave)="hidePopup()">
          <a class="nav-link nav-link-toggle" (click)="toggleSubMenu('masterData')"
             [attr.title]="isCollapsedView ? null : null"
             [attr.aria-expanded]="subMenuStates['masterData']"
             [class.expanded]="subMenuStates['masterData']">
          <span class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
              <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
              <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
            </svg>
          </span>
            <span class="nav-text">ข้อมูลพื้นฐาน</span>
            @if (!isCollapsedView) {
              @if (subMenuStates['masterData']) {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              }
            }
          </a>

          @if (isCollapsedView) {
            <div class="nav-popup">
              <div class="nav-popup-header">
                <span class="nav-popup-title">ข้อมูลพื้นฐาน</span>
              </div>
              <ul class="nav-popup-list">
                <li class="nav-popup-item">
                  <a routerLink="/standard-types" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">หมวดรหัสมาตรฐานสินค้า</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/standard-codes" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">รหัสมาตรฐานสินค้า</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/product-group-types" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ลักษณะกลุ่มสินค้า</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/product-groups" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">กลุ่มสินค้า</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/product-codes" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">รหัสชนิดสินค้า</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/product-code-subs" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ประเภทสินค้า(ย่อย)</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/provinces" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ข้อมูลจังหวัด</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/districts" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ข้อมูลอำเภอ</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/subdistricts" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ข้อมูลตำบล/แขวง</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/postcodes" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ข้อมูลรหัสไปรษณีย์</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/country" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ข้อมูลรายชื่อประเทศตาม ISO 3166</span>
                  </a>
                </li>
<!--                <li class="nav-popup-item">-->
<!--                  <a routerLink="/business-types" routerLinkActive="active" class="nav-popup-link">-->
<!--                    <span class="nav-popup-text">ข้อมูลประเภทธุรกิจ</span>-->
<!--                  </a>-->
<!--                </li>-->
                <li class="nav-popup-item">
                  <a routerLink="/departments" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ข้อมูลผู้ประกอบการตรวจสอบมาตรฐาน</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/sub-cbs" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ข้อมูลหน่วยตรวจสอบย่อย</span>
                  </a>
                </li>
<!--                <li class="nav-popup-item">-->
<!--                  <a routerLink="/units" routerLinkActive="active" class="nav-popup-link">-->
<!--                    <span class="nav-popup-text">ข้อมูลหน่วยนับ</span>-->
<!--                  </a>-->
<!--                </li>-->
                <li class="nav-popup-item">
                  <a routerLink="/certificate-authority" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ผู้ให้บริการออกใบรับรองอิเล็กทรอนิกส์ (CA)</span>
                  </a>
                </li>
<!--                <li class="nav-popup-item">-->
<!--                  <a routerLink="/setting-bans" routerLinkActive="active" class="nav-popup-link">-->
<!--                    <span class="nav-popup-text">ระบบจัดการคำต้องห้าม</span>-->
<!--                  </a>-->
<!--                </li>-->
              </ul>
            </div>
          }
        </li>
      </ul>

      <ul class="nav-list nav-submenu" [hidden]="!isAdmin()"
          [class.collapsed]="isCollapsedView || !subMenuStates['masterData']">
        <li class="nav-item">
          <a routerLink="/standard-types" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'หมวดรหัสมาตรฐานสินค้า' : null">
            <span class="nav-text">หมวดรหัสมาตรฐานสินค้า</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/standard-codes" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'รหัสมาตรฐานสินค้า' : null">
            <span class="nav-text">รหัสมาตรฐานสินค้า</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/product-group-types" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ลักษณะกลุ่มสินค้า' : null">
            <span class="nav-text">ลักษณะกลุ่มสินค้า</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/product-groups" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'กลุ่มสินค้า' : null">
            <span class="nav-text">กลุ่มสินค้า</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/product-codes" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'รหัสชนิดสินค้า' : null">
            <span class="nav-text">รหัสชนิดสินค้า</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/product-code-subs" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ประเภทสินค้า(ย่อย)' : null">
            <span class="nav-text">ประเภทสินค้า(ย่อย)</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/provinces" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ข้อมูลจังหวัด' : null">
            <span class="nav-text">ข้อมูลจังหวัด</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/districts" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ข้อมูลอำเภอ' : null">
            <span class="nav-text">ข้อมูลอำเภอ</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/subdistricts" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ข้อมูลตำบล/แขวง' : null">
            <span class="nav-text">ข้อมูลตำบล/แขวง</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/postcodes" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ข้อมูลรหัสไปรษณีย์' : null">
            <span class="nav-text">ข้อมูลรหัสไปรษณีย์</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/country" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ข้อมูลรายชื่อประเทศตาม ISO 3166' : null">
            <span class="nav-text">ข้อมูลรายชื่อประเทศตาม ISO 3166</span>
          </a>
        </li>
<!--        <li class="nav-item">-->
<!--          <a routerLink="/business-types" routerLinkActive="active" class="nav-link"-->
<!--             [attr.title]="isCollapsedView ? 'ข้อมูลประเภทธุรกิจ' : null">-->
<!--            <span class="nav-text">ข้อมูลประเภทธุรกิจ</span>-->
<!--          </a>-->
<!--        </li>-->
        <li class="nav-item">
          <a routerLink="/departments" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ข้อมูลผู้ประกอบการตรวจสอบมาตรฐาน' : null">
            <span class="nav-text">ข้อมูลผู้ประกอบการตรวจสอบมาตรฐาน</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/sub-cbs" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ข้อมูลหน่วยตรวจสอบย่อย' : null">
            <span class="nav-text">ข้อมูลหน่วยตรวจสอบย่อย</span>
          </a>
        </li>
<!--        <li class="nav-item">-->
<!--          <a routerLink="/units" routerLinkActive="active" class="nav-link"-->
<!--             [attr.title]="isCollapsedView ? 'ข้อมูลหน่วยนับ' : null">-->
<!--            <span class="nav-text">ข้อมูลหน่วยนับ</span>-->
<!--          </a>-->
<!--        </li>-->
        <li class="nav-item">
          <a routerLink="/certificate-authority" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ผู้ให้บริการออกใบรับรองอิเล็กทรอนิกส์ (CA)' : null">
            <span class="nav-text">ผู้ให้บริการออกใบรับรองอิเล็กทรอนิกส์ (CA)</span>
          </a>
        </li>
<!--        <li class="nav-item">-->
<!--          <a routerLink="/setting-bans" routerLinkActive="active" class="nav-link"-->
<!--             [attr.title]="isCollapsedView ? 'ระบบจัดการคำต้องห้าม' : null">-->
<!--            <span class="nav-text">ระบบจัดการคำต้องห้าม</span>-->
<!--          </a>-->
<!--        </li>-->
      </ul>

      <ul class="nav-list" [hidden]="!isStaff()">
        <li class="nav-item nav-item-has-popup" (mouseenter)="showPopup('settings')" (mouseleave)="hidePopup()">
          <a class="nav-link nav-link-toggle" (click)="toggleSubMenu('settings')"
             [attr.title]="isCollapsedView ? null : null"
             [attr.aria-expanded]="subMenuStates['settings']"
             [class.expanded]="subMenuStates['settings']">
          <span class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"></circle>
              <path
                d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
          </span>
            <span class="nav-text">ตั้งค่า</span>
            @if (!isCollapsedView) {
              @if (subMenuStates['settings']) {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              }
            }
          </a>

          @if (isCollapsedView) {
            <div class="nav-popup">
              <div class="nav-popup-header">
                <span class="nav-popup-title">ตั้งค่า</span>
              </div>
              <ul class="nav-popup-list">
<!--                <li class="nav-popup-item" [hidden]="!isAdmin()">-->
<!--                  <a routerLink="/activity-logs" routerLinkActive="active" class="nav-popup-link">-->
<!--                    <span class="nav-popup-text">ตั้งค่าสถานะ Log</span>-->
<!--                  </a>-->
<!--                </li>-->
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/line" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ตั้งค่า LINE</span>
                  </a>
                </li>
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/log-retention" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">จำนวนวันเก็บ Log</span>
                  </a>
                </li>
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/ws-settings" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ตั้งค่าข้อมูล API</span>
                  </a>
                </li>
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/wss" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ผู้ใช้งาน Web Service API</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/tas-license-mokoso2" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">API Tas-License สำหรับผู้ผลิต</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/cab-permit-approved" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">API CAB Service</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/tas2go-standard" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">API Tas2Go</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/gdx-juristic" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">GDX ค้นหาข้อมูลนิติบุคคล</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/gdx-cooperative" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">GDX ค้นหาข้อมูลจดทะเบียนสหกรณ์</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/gdx-smce" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ค้นหาข้อมูลวิสาหกิจชุมชน</span>
                  </a>
                </li>
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/smce-scrape" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ดึงข้อมูลวิสาหกิจชุมชน</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/standard-logo-sync" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">เครื่องหมายมาตรฐาน (ThaiTraces)</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/user-lk2-token" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ข้อมูล Token LK2</span>
                  </a>
                </li>
              </ul>
            </div>
          }
        </li>
      </ul>

      <ul class="nav-list nav-submenu" [hidden]="!isStaff()"
          [class.collapsed]="isCollapsedView || !subMenuStates['settings']">
<!--        <li class="nav-item" [hidden]="!isAdmin()">-->
<!--          <a routerLink="/activity-logs" routerLinkActive="active" class="nav-link"-->
<!--             [attr.title]="isCollapsedView ? 'ตั้งค่าสถานะ Log' : null">-->
<!--            <span class="nav-text">ตั้งค่าสถานะ Log</span>-->
<!--          </a>-->
<!--        </li>-->
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/line" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ตั้งค่า LINE' : null">
            <span class="nav-text">ตั้งค่า LINE</span>
          </a>
        </li>
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/log-retention" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'จำนวนวันเก็บ Log' : null">
            <span class="nav-text">จำนวนวันเก็บ Log</span>
          </a>
        </li>
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/ws-settings" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ตั้งค่าข้อมูล API' : null">
            <span class="nav-text">ตั้งค่าข้อมูล API</span>
          </a>
        </li>
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/wss" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ผู้ใช้งาน Web Service API' : null">
            <span class="nav-text">ผู้ใช้งาน Web Service API</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/tas-license-mokoso2" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'API Tas-License สำหรับผู้ผลิต' : null">
            <span class="nav-text">API Tas-License สำหรับผู้ผลิต</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/cab-permit-approved" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'API CAB Service' : null">
            <span class="nav-text">API CAB Service</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/tas2go-standard" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'API Tas2Go' : null">
            <span class="nav-text">API Tas2Go</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/gdx-juristic" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'GDX ค้นหาข้อมูลนิติบุคคล' : null">
            <span class="nav-text">GDX ค้นหาข้อมูลนิติบุคคล</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/gdx-cooperative" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'GDX ค้นหาข้อมูลจดทะเบียนสหกรณ์' : null">
            <span class="nav-text">GDX ค้นหาข้อมูลจดทะเบียนสหกรณ์</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/gdx-smce" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ค้นหาข้อมูลวิสาหกิจชุมชน' : null">
            <span class="nav-text">ค้นหาข้อมูลวิสาหกิจชุมชน</span>
          </a>
        </li>
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/smce-scrape" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'GDX ดึงข้อมูลวิสาหกิจชุมชน' : null">
            <span class="nav-text">ดึงข้อมูลวิสาหกิจชุมชน</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/standard-logo-sync" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'เครื่องหมายมาตรฐาน (ThaiTraces)' : null">
            <span class="nav-text">เครื่องหมายมาตรฐาน (ThaiTraces)</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/user-lk2-token" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ข้อมูล Token LK2' : null">
            <span class="nav-text">ข้อมูล Token LK2</span>
          </a>
        </li>
      </ul>

      <ul class="nav-list" [hidden]="!isStaff()">
        <li class="nav-item nav-item-has-popup" (mouseenter)="showPopup('report')" (mouseleave)="hidePopup()">
          <a class="nav-link nav-link-toggle" (click)="toggleSubMenu('report')"
             [attr.aria-expanded]="subMenuStates['report']"
             [class.expanded]="subMenuStates['report']">
            <span class="nav-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </span>
            <span class="nav-text">รายงาน</span>
            @if (!isCollapsedView) {
              @if (subMenuStates['report']) {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              }
            }
          </a>

          @if (isCollapsedView) {
            <div class="nav-popup">
              <div class="nav-popup-header">
                <span class="nav-popup-title">รายงาน</span>
              </div>
              <ul class="nav-popup-list">
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/reports/tas-logs" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">Log การเรียกข้อมูล TAS</span>
                  </a>
                </li>
<!--                <li class="nav-popup-item" [hidden]="!isAdmin()">-->
<!--                  <a routerLink="/reports/thaitraces-req-log" routerLinkActive="active" class="nav-popup-link">-->
<!--                    <span class="nav-popup-text">Log การเรียกข้อมูล ThaiTraces</span>-->
<!--                  </a>-->
<!--                </li>-->
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/reports/ws-logs" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">Log การเชื่อมโยงข้อมูล ThaiTraces</span>
                  </a>
                </li>
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/reports/thaitraces-delivery-queue" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">คิวส่งสถานะ ThaiTraces</span>
                  </a>
                </li>
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/reports/sign-log" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">Log การลงลายมือชื่อ</span>
                  </a>
                </li>
                <li class="nav-popup-item" [hidden]="!isAdmin()">
                  <a routerLink="/reports/activity-log-report" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">รายการบันทึกกิจกรรม (Log)</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/reports/system-usage-summary" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">รายงานสรุปการใช้งานภายในระบบ</span>
                  </a>
                </li>
              </ul>
            </div>
          }
        </li>
      </ul>

      <ul class="nav-list nav-submenu" [hidden]="!isStaff()"
          [class.collapsed]="isCollapsedView || !subMenuStates['report']">
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/reports/tas-logs" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'Log การเรียกข้อมูล TAS' : null">
            <span class="nav-text">Log การเรียกข้อมูล TAS</span>
          </a>
        </li>
<!--        <li class="nav-item" [hidden]="!isAdmin()">-->
<!--          <a routerLink="/reports/thaitraces-req-log" routerLinkActive="active" class="nav-link"-->
<!--             [attr.title]="isCollapsedView ? 'Log การเรียกข้อมูล ThaiTraces' : null">-->
<!--            <span class="nav-text">Log การเรียกข้อมูล ThaiTraces</span>-->
<!--          </a>-->
<!--        </li>-->
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/reports/ws-logs" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'Log การเชื่อมโยงข้อมูล ThaiTraces' : null">
            <span class="nav-text">Log การเชื่อมโยงข้อมูล ThaiTraces</span>
          </a>
        </li>
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/reports/thaitraces-delivery-queue" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'คิวส่งสถานะ ThaiTraces' : null">
            <span class="nav-text">คิวส่งสถานะ ThaiTraces</span>
          </a>
        </li>
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/reports/sign-log" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'Log การลงลายมือชื่อ' : null">
            <span class="nav-text">Log การลงลายมือชื่อ</span>
          </a>
        </li>
        <li class="nav-item" [hidden]="!isAdmin()">
          <a routerLink="/reports/activity-log-report" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'รายการบันทึกกิจกรรม (Log)' : null">
            <span class="nav-text">รายการบันทึกกิจกรรม (Log)</span>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/reports/system-usage-summary" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'รายงานสรุปการใช้งานภายในระบบ' : null">
            <span class="nav-text">รายงานสรุปการใช้งานภายในระบบ</span>
          </a>
        </li>
      </ul>

      <!--      <ul class="nav-list">-->
      <!--        <li class="nav-item">-->
      <!--          <a routerLink="/pr/pages" routerLinkActive="active" class="nav-link"-->
      <!--             [attr.title]="isCollapsedView ? 'จัดการเพจประชาสัมพันธ์' : null">-->
      <!--            <span class="nav-icon">-->
      <!--              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"-->
      <!--                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"-->
      <!--                   class="lucide lucide-megaphone-icon lucide-megaphone">-->
      <!--                <path-->
      <!--                  d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"/>-->
      <!--                <path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14"/>-->
      <!--                <path d="M8 6v8"/>-->
      <!--              </svg>-->
      <!--            </span>-->
      <!--            <span class="nav-text">เพจประชาสัมพันธ์</span>-->
      <!--          </a>-->
      <!--        </li>-->
      <!--      </ul>-->

      <ul class="nav-list" [hidden]="!isStaff()">
        <li class="nav-item nav-item-has-popup" (mouseenter)="showPopup('surveyChatArticle')"
            (mouseleave)="hidePopup()">
          <a class="nav-link nav-link-toggle" (click)="toggleSubMenu('surveyChatArticle')"
             [attr.title]="isCollapsedView ? null : null"
             [attr.aria-expanded]="subMenuStates['surveyChatArticle']"
             [class.expanded]="subMenuStates['surveyChatArticle']">
          <span class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              <path d="M8 9h8"></path>
              <path d="M8 13h5"></path>
            </svg>
          </span>
            <span class="nav-text">แชท/บทความ</span>
            @if (!isCollapsedView) {
              @if (subMenuStates['surveyChatArticle']) {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="feather-caret">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              }
            }
          </a>

          @if (isCollapsedView) {
            <div class="nav-popup">
              <div class="nav-popup-header">
                <span class="nav-popup-title">แชท/บทความ</span>
              </div>
              <ul class="nav-popup-list">
                <li class="nav-popup-item">
                  <a routerLink="/campaigns/chat-history" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">ประวัติแชท</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/campaigns/articles" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">บทความ</span>
                  </a>
                </li>
                <li class="nav-popup-item">
                  <a routerLink="/survey" routerLinkActive="active" class="nav-popup-link">
                    <span class="nav-popup-text">แบบสอบถาม</span>
                  </a>
                </li>
              </ul>
            </div>
          }
        </li>
      </ul>

      <ul class="nav-list nav-submenu" [hidden]="!isStaff()"
          [class.collapsed]="isCollapsedView || !subMenuStates['surveyChatArticle']">
        <li class="nav-item">
          <a routerLink="/campaigns/chat-history" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'ประวัติแชท' : null">
            <span class="nav-text">ประวัติแชท</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/campaigns/articles" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'บทความ' : null">
            <span class="nav-text">บทความ</span>
          </a>
        </li>

        <li class="nav-item">
          <a routerLink="/survey" routerLinkActive="active" class="nav-link"
             [attr.title]="isCollapsedView ? 'แบบสอบถาม' : null">
            <span class="nav-text">แบบสอบถาม</span>
          </a>
        </li>
      </ul>

      <!--      @if (!isCollapsedView) {-->
      <!--        <div class="nav-section">-->
      <!--          <span class="nav-section-title">Management</span>-->
      <!--        </div>-->
      <!--      }-->

      <!--      <ul class="nav-list">-->
      <!--        <li class="nav-item">-->
      <!--          <a routerLink="/settings" routerLinkActive="active" class="nav-link"-->
      <!--             [attr.title]="isCollapsedView ? 'Settings' : null">-->
      <!--            <span class="nav-icon">-->
      <!--              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"-->
      <!--                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">-->
      <!--                <circle cx="12" cy="12" r="3"></circle>-->
      <!--                <path-->
      <!--                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">-->
      <!--                </path>-->
      <!--              </svg>-->
      <!--            </span>-->
      <!--            <span class="nav-text">Settings</span>-->
      <!--          </a>-->
      <!--        </li>-->

      <!--        <li class="nav-item">-->
      <!--          <a routerLink="/help" routerLinkActive="active" class="nav-link"-->
      <!--             [attr.title]="isCollapsedView ? 'Help Center' : null">-->
      <!--            <span class="nav-icon">-->
      <!--              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"-->
      <!--                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">-->
      <!--                <circle cx="12" cy="12" r="10"></circle>-->
      <!--                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>-->
      <!--                <line x1="12" y1="17" x2="12.01" y2="17"></line>-->
      <!--              </svg>-->
      <!--            </span>-->
      <!--            <span class="nav-text">Help Center</span>-->
      <!--          </a>-->
      <!--        </li>-->
      <!--      </ul>-->
    </nav>

    <!-- Sidebar Footer -->
    <!--    @if (!isCollapsedView) {-->
    <!--      <div class="sidebar-footer">-->
    <!--        <div class="sidebar-footer-content">-->
    <!--          <div class="footer-icon">-->
    <!--            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>-->
    <!--          </div>-->
    <!--          <div class="footer-text">-->
    <!--            <span class="footer-title">Need Help?</span>-->
    <!--            <span class="footer-subtitle">Contact Support</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    }-->
  </aside>

  <!-- Mobile Overlay Backdrop -->
  <div class="sidebar-overlay" [class.show]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

  <!-- Main Content -->
  <div class="main-content" [class.sidebar-collapsed]="isCollapsedView">
    <!-- Top Navbar -->
    <header class="top-navbar">
      <div class="navbar-left">
        <button class="sidebar-toggle" (click)="toggleSidebar()"
                [title]="isMobileMenuOpen ? 'Close Menu' : (isCollapsedView ? 'Expand Sidebar' : 'Collapse Sidebar')">
          @if (isMobileView()) {
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          } @else if (isCollapsedView) {
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
              <polyline points="19 18 13 12 19 6"></polyline>
            </svg>
          } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          }
        </button>

        @if (isMobileView()) {
          <a routerLink="/secure/admin" class="navbar-brand-mobile">
            <img src="images/logo2.png" alt="Logo" class="navbar-brand-logo" />
            <span class="navbar-brand-text">ACFS e-Coding</span>
          </a>
        }
      </div>

      <div class="navbar-right d-flex align-items-center gap-3">
        <app-floating-chat class="nav-chat"></app-floating-chat>
        <!-- User Menu -->
        <div class="nav-item dropdown" ngbDropdown container="body" display="dynamic"
             placement="bottom-end bottom-start">
          <button class="user-menu-btn" ngbDropdownToggle>
            <div class="user-avatar">
              @let initials = getInitial(user?.name?.split(' ')?.[0]) + getInitial(user?.name?.split(' ')?.slice(-1)?.[0]);
              <span>{{ initials.toUpperCase() }}</span>
            </div>
            <div class="user-info">
              <span class="user-name">{{ user?.name }}</span>
              <span class="user-role">{{ user?.role }}</span>
            </div>
          </button>
          <div class="dropdown-menu dropdown-menu-end user-dropdown" ngbDropdownMenu>
            <div class="user-dropdown-header">
              <div class="user-avatar large">
                <span>{{ initials.toUpperCase() }}</span>
              </div>
              <div class="user-details">
                <h6>{{ user?.name }}</h6>
                <p>{{ user?.email }}</p>
              </div>
            </div>
            <a href="#" class="dropdown-item" (click)="goToPortalProfile($event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              จัดการบัญชีผู้ใช้
            </a>
            <a href="#" class="dropdown-item" (click)="openCertificateInfo($event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3l7 4v5c0 5-3.5 9.7-7 11-3.5-1.3-7-6-7-11V7l7-4z"></path>
                <path d="M9 12l2 2 4-4"></path>
              </svg>
              ข้อมูลใบรับรองอิเล็กทรอนิกส์
            </a>
            <a (click)="logout()" class="dropdown-item text-danger">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              Logout
            </a>
          </div>
        </div>
      </div>
    </header>
    @if (!isMobileView()) {
      <app-breadcrumb></app-breadcrumb>
    }
    <!-- Page Content -->
    <main class="page-content mt-3">
      <div class="container-fruid" style="">
        <app-toasts></app-toasts>
        <app-loading></app-loading>
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
